import initialState from './state'

export default {
  LOAD_SCENE (state, { scene, view, data }) {
    state.paused = false
    state.scene = scene
    state.view = view
    state.data = data
  },
  UPDATE_SCENE (state, data) {
    state.data = Object.assign({}, state.data || {}, data)
  },
  SELECT_PLAYER (state, player) {
    state.player = player
  },
  SELECT_CHARACTER (state, character) {
    state.character = character
  },
  SELECT_STORY (state, id) {
    const history = new Set([...state.history, id])
    state.history = [...history]
  },
  PAUSE (state) {
    state.paused = true
  },
  RESUME (state) {
    state.paused = false
  },
  RESET (state) {
    Object.assign(state, initialState)
  }
}
